import { useEffect, useState, useCallback } from "react";

export function useLocalPref(key, initial) {
  const [val, setVal] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return typeof initial === "function" ? initial() : initial;
      return JSON.parse(raw);
    } catch {
      return typeof initial === "function" ? initial() : initial;
    }
  });
  const update = useCallback((next) => {
    setVal((prev) => {
      const value = typeof next === "function" ? next(prev) : next;
      try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
      return value;
    });
  }, [key]);
  useEffect(() => {
    const handler = (e) => {
      if (e.key === key) {
        try { setVal(JSON.parse(e.newValue)); } catch {}
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [key]);
  return [val, update];
}
